// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Table,
//   Button,
//   Spinner,
//   Alert,
//   InputGroup,
//   Form,
//   Row,
//   Col,
//   Pagination,
// } from "react-bootstrap";
// import { useParams, useNavigate } from "react-router-dom";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import { FaArrowLeft, FaDownload, FaTimes } from "react-icons/fa";
// import { BsEye } from "react-icons/bs";
// import "./ServitorOrderHistoryDetails.css";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";

// export default function ServitorOrderHistoryDetails() {
//   const { servitorId } = useParams();
//   const navigate = useNavigate();
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [servitorName, setServitorName] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterStatus, setFilterStatus] = useState("All");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const token = localStorage.getItem("adminToken");

//   const [showModal, setShowModal] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const modalRef = useRef(null);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       setLoading(true);
//       try {
//         const { data } = await axios.get(
//           `${URL}/admin/servitors/${servitorId}/orders`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         setOrders(data);
//         setFilteredOrders(data);
//         const servitorResponse = await axios.get(
//           `${URL}/admin/servitors/metrics`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );
//         const numericId = Number(servitorId);
//         const servitor = servitorResponse.data.find((s) => s.id === numericId);
//         setServitorName(servitor?.name || "Unknown Servitor");
//         setError("");
//       } catch (err) {
//         setError("Could not load orders or servitor details.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchOrders();
//   }, [servitorId, token]);

//   useEffect(() => {
//     let results = orders;
//     if (searchTerm) {
//       results = results.filter((order) =>
//         order.order_number?.toString().includes(searchTerm)
//       );
//     }
//     if (filterStatus !== "All") {
//       results = results.filter(
//         (order) => order.status.toLowerCase() === filterStatus.toLowerCase()
//       );
//     }
//     setFilteredOrders(results);
//     setCurrentPage(1);
//   }, [searchTerm, filterStatus, orders]);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);

//     if (current <= siblings + 2) {
//       end = Math.min(total - 1, maxButtons - 1);
//     }
//     if (current >= total - (siblings + 1)) {
//       start = Math.max(2, total - (maxButtons - 2));
//     }

//     if (start > 2) {
//       pages.push("start-ellipsis");
//     }

//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }

//     if (end < total - 1) {
//       pages.push("end-ellipsis");
//     }

//     if (total > 1) {
//       pages.push(total);
//     }

//     return pages;
//   };

//   const exportPDF = async () => {
//     if (orders.length === 0) return;

//     const doc = new jsPDF({
//       orientation: "landscape",
//       unit: "pt",
//       format: "a4",
//     });
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const titleText = `Order History -- ${servitorName} (#${servitorId})`;
//     const timestampText = `Generated: ${new Date().toLocaleString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//       hour: "numeric",
//       minute: "2-digit",
//       second: "2-digit",
//       hour12: true,
//     })}`;
//     const rowsPerPage = 15;
//     const totalPages = Math.ceil(orders.length / rowsPerPage);

//     const renderPage = async (pageIndex) => {
//       const sliceStart = pageIndex * rowsPerPage;
//       const slice = orders.slice(sliceStart, sliceStart + rowsPerPage);

//       const wrapper = document.createElement("div");
//       Object.assign(wrapper.style, {
//         position: "absolute",
//         top: "-9999px",
//         left: "-9999px",
//         width: "800px",
//         padding: "10px",
//         fontSize: "10px",
//         background: "white",
//         color: "black",
//         fontFamily: "Helvetica, Arial, sans-serif",
//       });

//       const h2 = document.createElement("h2");
//       h2.innerText = titleText;
//       h2.style.textAlign = "center";
//       h2.style.margin = "0 0 5px 0";
//       wrapper.appendChild(h2);

//       const info = document.createElement("div");
//       info.style.display = "flex";
//       info.style.justifyContent = "space-between";
//       info.style.fontSize = "8px";
//       info.innerHTML = `
//         <span>${timestampText}</span>
//         <span>Page ${pageIndex + 1} of ${totalPages}</span>
//       `;
//       wrapper.appendChild(info);

//       const table = document.createElement("table");
//       table.style.width = "100%";
//       table.style.borderCollapse = "collapse";
//       table.style.marginTop = "5px";
//       table.innerHTML = `
//         <thead>
//           <tr>
//             <th style="border:1px solid #444; padding:4px;">#</th>
//             <th style="border:1px solid #444; padding:4px;">Order #</th>
//             <th style="border:1px solid #444; padding:4px;">Service</th>
//             <th style="border:1px solid #444; padding:4px;">Status</th>
//             <th style="border:1px solid #444; padding:4px;">Amount (Tk)</th>
//             <th style="border:1px solid #444; padding:4px;">Date</th>
//             <th style="border:1px solid #444; padding:4px;">Time</th>
//           </tr>
//         </thead>
//         <tbody>
//           ${slice
//             .map((o, idx) => {
//               const globalIdx = sliceStart + idx + 1;
//               const date = new Date(o.created_at);
//               return `
//                 <tr>
//                   <td style="border:1px solid #444; padding:4px;">${globalIdx}</td>
//                   <td style="border:1px solid #444; padding:4px;">${
//                     o.order_number
//                   }</td>
//                   <td style="border:1px solid #444; padding:4px;">${
//                     o.service_name
//                   }</td>
//                   <td style="border:1px solid #444; padding:4px;">${
//                     o.status
//                   }</td>
//                   <td style="border:1px solid #444; padding:4px; text-align:right;">
//                     ${o.price} Tk
//                   </td>
//                   <td style="border:1px solid #444; padding:4px;">
//                     ${date.toLocaleDateString()}
//                   </td>
//                   <td style="border:1px solid #444; padding:4px;">
//                     ${date.toLocaleTimeString()}
//                   </td>
//                 </tr>
//               `;
//             })
//             .join("")}
//         </tbody>
//       `;
//       wrapper.appendChild(table);

//       document.body.appendChild(wrapper);
//       const canvas = await html2canvas(wrapper, { scale: 2 });
//       document.body.removeChild(wrapper);

//       const imgData = canvas.toDataURL("image/png");
//       const margin = 20;
//       const imgWidth = pageWidth - margin * 2;
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
//       const y = margin;
//       if (pageIndex > 0) doc.addPage();
//       doc.addImage(imgData, "PNG", margin, y, imgWidth, imgHeight);
//     };

//     for (let i = 0; i < totalPages; i++) {
//       await renderPage(i);
//     }

//     doc.save(
//       `Servitor_${servitorId}_Orders_${
//         new Date().toISOString().split("T")[0]
//       }.pdf`
//     );
//   };

//   const handleViewOrder = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) {
//         handleCloseModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") {
//         handleCloseModal();
//       }
//     };

//     if (node) {
//       node.addEventListener("click", handleBackdropClick);
//     }
//     document.addEventListener("keydown", handleEscapeKey);

//     return () => {
//       if (node) {
//         node.removeEventListener("click", handleBackdropClick);
//       }
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;

//     const {
//       order_number,
//       service_name,
//       status,
//       price,
//       created_at,
//       feedback,
//       rating,

//       // electrician fields
//       Fan_in_un,
//       Light_in_un,
//       Fan_repair,
//       Light_repair,
//       Doorbell_setup,
//       Exhaust_fan_setup,
//       Exhaust_fan_repair,
//       Drill_wall_holes,
//       Switch_repair,
//       MCB_service,
//       MDB_service,
//       Fan_regulator_in_un,
//       Fan_regulator_repair,
//       Socket_in_un,
//       Socket_repair,
//       Circuit_breaker_repair,
//       New_wiring_point,
//       Coil_repair,
//       // Full_wiring,
//       Electrical_checkup,

//       // homeclean fields …
//       bed,
//       bath,
//       dra_din,
//       kitchen,
//       cloth,
//       dish,
//       balcony,
//       window_grill,
//       stairs_and_railing,
//       carpet_cleaning,
//       furniture_cleaning,

//       // plumber fields …
//       Toilet_in,
//       Faucet_in,
//       Sink_in,
//       Dishwasher_in,
//       Leak_repair,
//       Faucet_repair,
//       Toilet_repair,
//       Shower_repair,
//       Drain_cleaning,
//       pipe_cleaning,
//       tank_cleaning,
//       geyser_setup,
//       geyser_repair,
//       issue_checkup,

//       // Gas Chula
//       chulaCylinderType,
//       NewchulaSetup,
//       chulaSetup,
//       burnerSetup,
//       burnerCleaning,
//       nozzleReplacement,
//       checkIssues,

//       // AC Service
//       acType,
//       acTon,
//       new_setup,
//       installation,
//       uninstallation,
//       gas_refill,
//       cleaning,
//       issue_checkup: ac_issue_checkup,

//       // Filter service
//       filter_type,
//       new_filter_setup,
//       installation_filter,
//       uninstallation_filter,
//       kit_replacement,
//       pipe_leak_or_replace,
//       full_servicing,
//       check_up,

//       // Tutor service
//       subject,
//       classLevel,
//       medium,
//       preferredTutorGender,
//       daysPerWeek,
//       hoursPerDay,
//       priorityInstitution,
//       salary,
//     } = selectedOrder;

//     return (
//       <div className="adminservitororderhistorydetails-modal">
//         <div className="adminservitororderhistorydetails-modal-header">
//           <button
//             className="adminservitororderhistorydetails-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminservitororderhistorydetails-service-icon">
//               <i className="fas fa-tools" style={{ color: "#f59e0b" }} />
//             </div>
//             <div>
//               <h2 className="adminservitororderhistorydetails-modal-title">
//                 Order Details - #{order_number}
//               </h2>
//               <p className="adminservitororderhistorydetails-modal-subtitle">
//                 {service_name} • {status}
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="adminservitororderhistorydetails-modal-body">
//           <div className="adminservitororderhistorydetails-summary-cards">
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-amount-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Amount
//                 </p>
//                 <p className="adminservitororderhistorydetails-price-value">
//                   ৳{price || 0}
//                 </p>
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-status-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Status
//                 </p>
//                 <p className="adminservitororderhistorydetails-count-value">
//                   {status}
//                 </p>
//               </div>
//               <i
//                 className={`fas ${
//                   status === "Completed" ? "fa-check-circle" : "fa-info-circle"
//                 }`}
//                 style={{
//                   color: status === "Completed" ? "#22c55e" : "#2563eb",
//                 }}
//               />
//             </div>
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-date-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Date & Time
//                 </p>
//                 <p className="adminservitororderhistorydetails-detail-value">
//                   {formatDateTime(created_at)}
//                 </p>
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-rating-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Rating
//                 </p>
//                 <p className="adminservitororderhistorydetails-rating-value">
//                   {rating ? rating.toFixed(1) : "N/A"} / 5
//                 </p>
//                 <div className="adminservitororderhistorydetails-star-container">
//                   {[...Array(5)].map((_, index) => (
//                     <i
//                       key={index}
//                       className="fas fa-star"
//                       style={{
//                         color:
//                           index < Math.round(rating || 0)
//                             ? "#f59e0b"
//                             : "#e5e7eb",
//                       }}
//                     />
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ─── SERVICE BREAKDOWN ─── */}
//           <div className="adminservitororderhistorydetails-detail-card">
//             <h3 className="adminservitororderhistorydetails-detail-title">
//               Order Breakdown
//             </h3>

//             {/* Electrician */}
//             {service_name === "Electrician" &&
//               (() => {
//                 const items = [
//                   ["Fans to Install", Fan_in_un],
//                   ["Lights to Install", Light_in_un],
//                   ["Fan Repairs", Fan_repair],
//                   ["Light Repairs", Light_repair],
//                   ["Doorbell Setup", Doorbell_setup],
//                   ["Exhaust Fan Setup", Exhaust_fan_setup],
//                   ["Exhaust Fan Repair", Exhaust_fan_repair],
//                   ["Drill Wall Holes", Drill_wall_holes],
//                   ["Switch Repairs", Switch_repair],
//                   ["MCB Service", MCB_service],
//                   ["MDB Service", MDB_service],
//                   ["Regulator Install", Fan_regulator_in_un],
//                   ["Regulator Repair", Fan_regulator_repair],
//                   ["Socket Install", Socket_in_un],
//                   ["Socket Repair", Socket_repair],
//                   ["Circuit Breaker Repair", Circuit_breaker_repair],
//                   ["New Wiring Points", New_wiring_point],
//                   ["Fan Coil Repair", Coil_repair],
//                   // ["Full Wiring", Full_wiring],
//                   ["Electrical Checkup", Electrical_checkup],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean" ? val : val > 0
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           {/* <span>{qty}</span> */}
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Home Cleaning */}
//             {service_name === "Home Cleaning" &&
//               (() => {
//                 const items = [
//                   ["Beds", bed],
//                   ["Baths", bath],
//                   ["Drawing/Dining Rooms", dra_din],
//                   ["Kitchen", kitchen],
//                   ["Cloth Wash", cloth],
//                   ["Dishwash", dish],
//                   ["Balconies", balcony],
//                   ["Window Grills", window_grill],
//                   ["Stairs & Railing Cleaning", stairs_and_railing],
//                   ["Carpet Cleaning", carpet_cleaning],
//                   ["Furniture Cleaning", furniture_cleaning],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       // .filter(([_, qty]) => qty > 0)
//                       .filter(([_, val]) =>
//                         typeof val === "boolean" ? val : val > 0
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           {/* <span>{qty}</span> */}
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Plumber */}
//             {service_name === "Plumber" &&
//               (() => {
//                 const items = [
//                   ["Toilets to Install", Toilet_in],
//                   ["Faucets to Install", Faucet_in],
//                   ["Sinks to Install", Sink_in],
//                   ["Dishwasher Installs", Dishwasher_in],
//                   ["Leak Repairs", Leak_repair],
//                   ["Faucet Repairs", Faucet_repair],
//                   ["Toilet Repairs", Toilet_repair],
//                   ["Shower Repairs", Shower_repair],
//                   ["Drain Cleaning", Drain_cleaning],
//                   ["Pipe Cleaning", pipe_cleaning],
//                   ["Tank Cleaning", tank_cleaning],
//                   ["Geyser Install", geyser_setup],
//                   ["Geyser Repair", geyser_repair],
//                   ["Issue Checkup", issue_checkup],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       // .filter(([_, qty]) => qty > 0)
//                       .filter(([_, val]) =>
//                         typeof val === "boolean" ? val : val > 0
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           {/* <span>{qty}</span> */}
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Gas Chula */}
//             {service_name === "Gas Chula" &&
//               (() => {
//                 const items = [
//                   ["Cylinder Type", chulaCylinderType],
//                   ["New Chula Setups", NewchulaSetup],
//                   ["Chula Setups", chulaSetup],
//                   ["Burner Setups", burnerSetup],
//                   ["Burner Cleaning", burnerCleaning],
//                   ["Nozzle Replacements", nozzleReplacement],
//                   ["Issue Checkup", checkIssues],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : false
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//               {/* AC Service */}
//             {service_name === "AC Service" &&
//               (() => {
//                 const items = [
//                   ["AC Type", acType],
//                   ["AC Ton",  acTon],
//                   ["New Setup",      new_setup],
//                   ["Installation",   installation],
//                   ["Uninstallation", uninstallation],
//                   ["Gas Refill",     gas_refill],
//                   ["Cleaning",       cleaning],
//                   ["Issue Checkup",  ac_issue_checkup],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : false
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//               {/* Filter */}
//             {service_name === "Filter" &&
//               (() => {
//                 const items = [
//                   ["Filter Type",             filter_type],
//                   ["New Filter Setup",        new_filter_setup],
//                   ["Filter Installation",     installation_filter],
//                   ["Filter Uninstallation",   uninstallation_filter],
//                   ["Kit Replacement",         kit_replacement],
//                   ["Pipe Leak / Replace",     pipe_leak_or_replace],
//                   ["Full Servicing",          full_servicing],
//                   ["Issue Checkup",           check_up],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : false
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//               {/* Tutor Service */}
//               {service_name === "Tutor Service" &&
//                (() => {
//                  // helper to ignore empty/"Any"
//                  const clean = (v) =>
//                    v !== undefined &&
//                    v !== null &&
//                    String(v).trim() !== "" &&
//                    String(v).trim().toLowerCase() !== "any";

//                  const items = [
//                    ["Subject",                subject],
//                    ["Class/Level",            classLevel || selectedOrder.class_level],
//                    ["Medium",                 medium],
//                    [
//                      "Preferred Tutor Gender",
//                      clean(preferredTutorGender) ? preferredTutorGender : null,
//                    ],
//                    [
//                      "Days per Week",
//                      daysPerWeek ? `${daysPerWeek} day${Number(daysPerWeek) > 1 ? "s" : ""}/week` : null,
//                    ],
//                    [
//                      "Hours per Day",
//                      hoursPerDay ? `${hoursPerDay} hour${Number(hoursPerDay) > 1 ? "s" : ""}/day` : null,
//                    ],
//                    ["Priority Institution",   priorityInstitution],
//                    ["Salary",                 salary ? `৳${salary}` : null],
//                  ];

//                  return (
//                    <ul className="adminservitororderhistorydetails-breakdown-list">
//                      {items
//                        .filter(([_, val]) =>
//                          typeof val === "boolean"
//                            ? val
//                            : typeof val === "number"
//                            ? val > 0
//                            : typeof val === "string"
//                            ? val.trim() !== ""
//                            : val !== null && val !== undefined
//                        )
//                        .map(([label, val]) => (
//                          <li key={label}>
//                            <span>{label}</span>
//                            <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                          </li>
//                        ))}
//                    </ul>
//                  );
//                })()}
//           </div>

//           <div className="adminservitororderhistorydetails-detail-card">
//             <h3 className="adminservitororderhistorydetails-detail-title">
//               <i
//                 className="fas fa-comment"
//                 style={{ marginRight: "8px", color: "#f59e0b" }}
//               />
//               Feedback
//             </h3>
//             <div className="adminservitororderhistorydetails-feedback-list">
//               {feedback ? (
//                 <div className="adminservitororderhistorydetails-feedback-item">
//                   <p className="adminservitororderhistorydetails-feedback-comment">
//                     {feedback}
//                   </p>
//                   <p className="adminservitororderhistorydetails-feedback-date">
//                     {formatDateTime(created_at)}
//                   </p>
//                   <hr className="adminservitororderhistorydetails-rating-underline" />
//                 </div>
//               ) : (
//                 <p className="adminservitororderhistorydetails-detail-value">
//                   No feedback available.
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="adminservitororderhistorydetails-modal-footer">
//           <div className="adminservitororderhistorydetails-footer-buttons">
//             <button
//               className="adminservitororderhistorydetails-footer-btn adminservitororderhistorydetails-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaTimes /> Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Calculate order counts
//   const totalOrders = orders.length;
//   const cancelledByServitor = orders.filter(
//     (o) => o.status === "Cancelled by Servitor"
//   ).length;
//   const cancelled = orders.filter((o) => o.status === "Cancelled").length;
//   const accepted = orders.filter((o) => o.status === "Accepted").length;
//   const completed = orders.filter((o) => o.status === "Completed").length;
//   const DeadlineTimeout = orders.filter(
//     (o) => o.status === "Deadline-Timeout"
//   ).length;

//   return (
//     <Container fluid className="adminservitororderhistorydetails-container">
//       <Card className="adminservitororderhistorydetails-card">
//         <Card.Header className="adminservitororderhistorydetails-header">
//           <div className="adminservitororderhistorydetails-header-content">
//             <Button
//               variant="outline-primary"
//               className="adminservitororderhistorydetails-back-btn"
//               onClick={() => navigate(-1)}
//             >
//               <FaArrowLeft size={14} /> Back
//             </Button>
//             <h3 className="adminservitororderhistorydetails-title">
//               Order History of {servitorName} (#Id-{servitorId})
//             </h3>
//           </div>
//         </Card.Header>
//         <Card.Body>
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="adminservitororderhistorydetails-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => setFilterStatus(e.target.value)}
//                   className="adminservitororderhistorydetails-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Completed">Completed</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="Cancelled by Servitor">
//                     Cancelled by Servitor
//                   </option>
//                   <option value="Cancelled">Cancelled</option>
//                   <option value="Deadline-Timeout">Deadline-Timeout</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* Clean Horizontal Statistics Cards */}
//           <div className="adminservitororderhistorydetails-stats-container">
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-blue">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-chart-bar"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 TOTAL ORDERS
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {totalOrders}
//               </div>
//             </div>

//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-orange">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-clock"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 ACCEPTED
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {accepted}
//               </div>
//             </div>

//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-green">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-check-circle"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 COMPLETED
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {completed}
//               </div>
//             </div>

//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-red">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-times-circle"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 CANCELLED
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {cancelled}
//               </div>
//             </div>

//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-yellow">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-hourglass-end"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 DEADLINE-TIMEOUT
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {DeadlineTimeout}
//               </div>
//             </div>

//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-purple">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-user-times"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 CANCELLED BY SERVITOR
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {cancelledByServitor}
//               </div>
//             </div>
//           </div>

//           {loading && (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           )}
//           {error && (
//             <Alert
//               variant="danger"
//               className="adminservitororderhistorydetails-error"
//             >
//               {error}
//             </Alert>
//           )}
//           {!loading && !error && filteredOrders.length === 0 && (
//             <p className="adminservitororderhistorydetails-empty-text">
//               No orders found for this servitor.
//             </p>
//           )}
//           {!loading && filteredOrders.length > 0 && (
//             <>
//               <div className="adminservitororderhistorydetails-table-actions">
//                 <Button
//                   className="adminservitororderhistorydetails-export-btn"
//                   onClick={exportPDF}
//                   disabled={orders.length === 0}
//                 >
//                   <FaDownload /> Download PDF
//                 </Button>
//               </div>
//               <Table
//                 striped
//                 bordered
//                 hover
//                 responsive
//                 className="adminservitororderhistorydetails-table"
//               >
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Order Number</th>
//                     <th>Service</th>
//                     <th>Status</th>
//                     <th>Amount (Tk)</th>
//                     <th>Date</th>
//                     <th>Time</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentItems.map((o, idx) => (
//                     <tr key={o.order_number || idx}>
//                       <td>{idx + 1 + indexOfFirstItem}</td>
//                       <td>{o.order_number}</td>
//                       <td>{o.service_name}</td>
//                       <td>
//                         <span
//                           className={`adminservitororderhistorydetails-badge-${o.status
//                             .toLowerCase()
//                             // .replace(" ", "-")
//                             .replace(/\s+/g, "-")}`}
//                         >
//                           {o.status}
//                         </span>
//                       </td>
//                       <td>{o.price}</td>
//                       {/* <td>{new Date(o.created_at).toLocaleDateString()}</td> */}
//                       <td>{formatDate(o.created_at)}</td>
//                       <td>{new Date(o.created_at).toLocaleTimeString()}</td>
//                       <td>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminservitororderhistorydetails-action-btn"
//                           onClick={() => handleViewOrder(o)}
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>

//               <Pagination>
//                 <Pagination.First
//                   onClick={() => handlePageChange(1)}
//                   disabled={currentPage === 1}
//                 />
//                 <Pagination.Prev
//                   onClick={() => handlePageChange(currentPage - 1)}
//                   disabled={currentPage === 1}
//                 />
//                 {getPageItems(totalPages, currentPage).map((item, idx) => {
//                   if (item === "start-ellipsis" || item === "end-ellipsis") {
//                     return <Pagination.Ellipsis key={item + idx} disabled />;
//                   }
//                   return (
//                     <Pagination.Item
//                       key={item}
//                       active={item === currentPage}
//                       onClick={() => handlePageChange(item)}
//                     >
//                       {item}
//                     </Pagination.Item>
//                   );
//                 })}
//                 <Pagination.Next
//                   onClick={() => handlePageChange(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                 />
//                 <Pagination.Last
//                   onClick={() => handlePageChange(totalPages)}
//                   disabled={currentPage === totalPages}
//                 />
//               </Pagination>
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div
//           className="adminservitororderhistorydetails-modal-backdrop"
//           ref={modalRef}
//         >
//           {renderOrderDetails()}
//         </div>
//       )}
//     </Container>
//   );
// }









// ***** Update with paginations (19-Oct-25) ***** // 
// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import {
//   Container,
//   Card,
//   Table,
//   Button,
//   Spinner,
//   Alert,
//   InputGroup,
//   Form,
//   Row,
//   Col,
//   Pagination,
// } from "react-bootstrap";
// import { useParams, useNavigate } from "react-router-dom";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import { FaArrowLeft, FaDownload, FaTimes } from "react-icons/fa";
// import { BsEye } from "react-icons/bs";
// import "./ServitorOrderHistoryDetails.css";
// import { formatDate } from "../../dateTimefrontpart";
// import { URL } from "../../../config";

// const DEFAULT_LIMIT = 10;

// export default function ServitorOrderHistoryDetails() {
//   const { servitorId } = useParams();
//   const navigate = useNavigate();

//   const [orders, setOrders] = useState([]);
//   const [servitorName, setServitorName] = useState("");
//   const [counts, setCounts] = useState({
//     totalOrders: 0,
//     accepted: 0,
//     completed: 0,
//     cancelled: 0,
//     cancelledByServitor: 0,
//     DeadlineTimeout: 0,
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // filters
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filterStatus, setFilterStatus] = useState("All");

//   // pagination meta
//   const [meta, setMeta] = useState({
//     page: 1,
//     limit: DEFAULT_LIMIT,
//     total: 0,
//     totalPages: 1,
//     sortBy: "created_at",
//     sortDir: "DESC",
//   });

//   const token = localStorage.getItem("adminToken");

//   // modal
//   const [showModal, setShowModal] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const modalRef = useRef(null);

//   const fetchPage = async () => {
//     setLoading(true);
//     try {
//       const { data } = await axios.get(
//         `${URL}/admin/servitors/${servitorId}/orders`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params: {
//             page: meta.page,
//             limit: meta.limit,
//             search: searchTerm,
//             status: filterStatus === "All" ? "" : filterStatus,
//             sortBy: meta.sortBy,
//             sortDir: meta.sortDir,
//           },
//         }
//       );

//       setOrders(Array.isArray(data?.data) ? data.data : []);
//       if (data?.meta) setMeta((m) => ({ ...m, ...data.meta }));
//       if (data?.counts) setCounts(data.counts);
//       if (data?.servitor?.name) setServitorName(data.servitor.name);

//       setError("");
//     } catch (err) {
//       setError("Could not load orders or servitor details.");
//       setOrders([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPage();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     meta.page,
//     meta.limit,
//     filterStatus,
//     searchTerm,
//     servitorId,
//     token,
//     meta.sortBy,
//     meta.sortDir,
//   ]);

//   const handlePageChange = (pageNumber) => {
//     setMeta((m) => ({ ...m, page: pageNumber }));
//   };

//   const exportPDF = async () => {
//     try {
//       // fetch ALL rows with current filters for export
//       const { data } = await axios.get(
//         `${URL}/admin/servitors/${servitorId}/orders`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params: {
//             page: 1,
//             limit: 999999, // export everything
//             search: searchTerm,
//             status: filterStatus === "All" ? "" : filterStatus,
//             sortBy: "created_at",
//             sortDir: "DESC",
//           },
//         }
//       );

//       const allOrders = Array.isArray(data?.data) ? data.data : [];
//       if (allOrders.length === 0) return;

//       const doc = new jsPDF({
//         orientation: "landscape",
//         unit: "pt",
//         format: "a4",
//       });
//       const pageWidth = doc.internal.pageSize.getWidth();
//       const titleText = `Order History -- ${servitorName} (#${servitorId})`;
//       const timestampText = `Generated: ${new Date().toLocaleString("en-US", {
//         day: "numeric",
//         month: "long",
//         year: "numeric",
//         hour: "numeric",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       })}`;
//       const rowsPerPage = 15;
//       const totalPages = Math.ceil(allOrders.length / rowsPerPage);

//       const renderPage = async (pageIndex) => {
//         const sliceStart = pageIndex * rowsPerPage;
//         const slice = allOrders.slice(sliceStart, sliceStart + rowsPerPage);

//         const wrapper = document.createElement("div");
//         Object.assign(wrapper.style, {
//           position: "absolute",
//           top: "-9999px",
//           left: "-9999px",
//           width: "800px",
//           padding: "10px",
//           fontSize: "10px",
//           background: "white",
//           color: "black",
//           fontFamily: "Helvetica, Arial, sans-serif",
//         });

//         const h2 = document.createElement("h2");
//         h2.innerText = titleText;
//         h2.style.textAlign = "center";
//         h2.style.margin = "0 0 5px 0";
//         wrapper.appendChild(h2);

//         const info = document.createElement("div");
//         info.style.display = "flex";
//         info.style.justifyContent = "space-between";
//         info.style.fontSize = "8px";
//         info.innerHTML = `<span>${timestampText}</span><span>Page ${
//           pageIndex + 1
//         } of ${totalPages}</span>`;
//         wrapper.appendChild(info);

//         const table = document.createElement("table");
//         table.style.width = "100%";
//         table.style.borderCollapse = "collapse";
//         table.style.marginTop = "5px";
//         table.innerHTML = `
//           <thead>
//             <tr>
//               <th style="border:1px solid #444; padding:4px;">#</th>
//               <th style="border:1px solid #444; padding:4px;">Order #</th>
//               <th style="border:1px solid #444; padding:4px;">Service</th>
//               <th style="border:1px solid #444; padding:4px;">Status</th>
//               <th style="border:1px solid #444; padding:4px;">Amount (Tk)</th>
//               <th style="border:1px solid #444; padding:4px;">Date</th>
//               <th style="border:1px solid #444; padding:4px;">Time</th>
//             </tr>
//           </thead>
//           <tbody>
//             ${slice
//               .map((o, idx) => {
//                 const globalIdx = sliceStart + idx + 1;
//                 const date = new Date(o.created_at);
//                 return `
//                 <tr>
//                   <td style="border:1px solid #444; padding:4px;">${globalIdx}</td>
//                   <td style="border:1px solid #444; padding:4px;">${
//                     o.order_number
//                   }</td>
//                   <td style="border:1px solid #444; padding:4px;">${
//                     o.service_name
//                   }</td>
//                   <td style="border:1px solid #444; padding:4px;">${
//                     o.status
//                   }</td>
//                   <td style="border:1px solid #444; padding:4px; text-align:right;">${
//                     o.price
//                   } Tk</td>
//                   <td style="border:1px solid #444; padding:4px;">${date.toLocaleDateString()}</td>
//                   <td style="border:1px solid #444; padding:4px;">${date.toLocaleTimeString()}</td>
//                 </tr>
//               `;
//               })
//               .join("")}
//           </tbody>
//         `;
//         wrapper.appendChild(table);

//         document.body.appendChild(wrapper);
//         const canvas = await html2canvas(wrapper, { scale: 2 });
//         document.body.removeChild(wrapper);

//         const imgData = canvas.toDataURL("image/png");
//         const margin = 20;
//         const imgWidth = pageWidth - margin * 2;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;
//         if (pageIndex > 0) doc.addPage();
//         doc.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
//       };

//       for (let i = 0; i < totalPages; i++) await renderPage(i);
//       doc.save(
//         `Servitor_${servitorId}_Orders_${
//           new Date().toISOString().split("T")[0]
//         }.pdf`
//       );
//     } catch {
//       // ignore
//     }
//   };

//   const handleViewOrder = (order) => {
//     setSelectedOrder(order);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };
//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedOrder(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) =>
//       node && e.target === node && handleCloseModal();
//     const handleEscapeKey = (e) => e.key === "Escape" && handleCloseModal();
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   const renderOrderDetails = () => {
//     if (!selectedOrder) return null;

//     const {
//       order_number,
//       service_name,
//       status,
//       price,
//       created_at,
//       feedback,
//       rating,

//       // electrician fields
//       new_ceiling_fan_installation,
//       ceiling_fan_installation,
//       ceiling_fan_uninstallation,
//       fan_coil_new_winding,
//       fan_coil_repair,
//       capacitor_setup,
//       light_installation,
//       light_repair,
//       exhaust_fan_installation,
//       exhaust_fan_cleaning,
//       switch_setup,
//       socket_setup,
//       regulator_setup,
//       new_wiring_point,
//       main_circuit_board_setup,
//       doorbell_installation,
//       drill_hole_service,
//       ips_installation_existing_line,
//       ips_new_line_installation,
//       Electrical_checkup,

//       // homeclean fields …
//       bed,
//       bath,
//       dra_din,
//       kitchen,
//       cloth,
//       dish,
//       balcony,
//       window_grill,
//       stairs_and_railing,
//       carpet_cleaning,
//       furniture_cleaning,

//       // plumber fields …
//       angle_valve_setup,
//       basin_tap_setup,
//       magic_pipe_setup,
//       basin_waste_pop_up_setup,
//       new_basin_setup_existing_lines,
//       bathroom_tap_bib_cock_setup,
//       tissue_holder_setup,
//       fill_valve_replacement,
//       hand_shower_setup,
//       soap_dish_setup,
//       bathroom_shelf_setup,
//       mirror_setup,
//       towel_hanger_setup,
//       shower_head_setup,
//       concealed_stopcock_setup,
//       floor_drain_net_setup,
//       toilet_seat_cover_replacement,
//       toilet_seat_complete_installation,
//       high_commode_installation_existing_lines,
//       blockage_clearing_high_commode,
//       blockage_clearing_low_commode,
//       bathroom_drain_line_cleaning,
//       geyser_installation,
//       kitchen_sink_setup_existing_lines,
//       sink_blockage_cleaning,
//       washing_machine_point_setup,
//       issue_checkup,

//       // Gas Chula
//       chulaCylinderType,
//       NewchulaSetup,
//       chulaSetup,
//       burnerSetup,
//       burnerCleaning,
//       nozzleReplacement,
//       checkIssues,

//       // AC Service
//       acType,
//       acTon,
//       // new_setup,
//       // installation,
//       // uninstallation,
//       // gas_refill,
//       // cleaning,
//       // issue_checkup: ac_issue_checkup,

//       installation_outdoor_inside,
//       installation_outdoor_outside,
//       uninstallation_outdoor_inside,
//       uninstallation_outdoor_outside,
//       cleaning_outdoor_inside,
//       cleaning_outdoor_outside,
//       issue_checkup: ac_issue_checkup,


//       // Filter service
//       filter_type,
//       new_filter_setup,
//       installation_filter,
//       uninstallation_filter,
//       kit_replacement,
//       pipe_leak_or_replace,
//       full_servicing,
//       check_up,

//       // Tutor service
//       subject,
//       classLevel,
//       medium,
//       preferredTutorGender,
//       daysPerWeek,
//       hoursPerDay,
//       priorityInstitution,
//       salary,
//     } = selectedOrder;

//     return (
//       <div className="adminservitororderhistorydetails-modal">
//         <div className="adminservitororderhistorydetails-modal-header">
//           <button
//             className="adminservitororderhistorydetails-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminservitororderhistorydetails-service-icon">
//               <i className="fas fa-tools" style={{ color: "#f59e0b" }} />
//             </div>
//             <div>
//               <h2 className="adminservitororderhistorydetails-modal-title">
//                 Order Details - #{order_number}
//               </h2>
//               <p className="adminservitororderhistorydetails-modal-subtitle">
//                 {service_name} • {status}
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="adminservitororderhistorydetails-modal-body">
//           <div className="adminservitororderhistorydetails-summary-cards">
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-amount-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Amount
//                 </p>
//                 <p className="adminservitororderhistorydetails-price-value">
//                   ৳{price || 0}
//                 </p>
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-status-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Status
//                 </p>
//                 <p className="adminservitororderhistorydetails-count-value">
//                   {status}
//                 </p>
//               </div>
//               <i
//                 className={`fas ${
//                   status === "Completed" ? "fa-check-circle" : "fa-info-circle"
//                 }`}
//                 style={{
//                   color: status === "Completed" ? "#22c55e" : "#2563eb",
//                 }}
//               />
//             </div>
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-date-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Date & Time
//                 </p>
//                 <p className="adminservitororderhistorydetails-detail-value">
//                   {formatDateTime(created_at)}
//                 </p>
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-rating-card">
//               <div>
//                 <p className="adminservitororderhistorydetails-detail-text">
//                   Rating
//                 </p>
//                 <p className="adminservitororderhistorydetails-rating-value">
//                   {rating ? rating.toFixed(1) : "N/A"} / 5
//                 </p>
//                 <div className="adminservitororderhistorydetails-star-container">
//                   {[...Array(5)].map((_, index) => (
//                     <i
//                       key={index}
//                       className="fas fa-star"
//                       style={{
//                         color:
//                           index < Math.round(rating || 0)
//                             ? "#f59e0b"
//                             : "#e5e7eb",
//                       }}
//                     />
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ─── SERVICE BREAKDOWN ─── */}
//           <div className="adminservitororderhistorydetails-detail-card">
//             <h3 className="adminservitororderhistorydetails-detail-title">
//               Order Breakdown
//             </h3>

//             {/* Electrician */}
//             {service_name === "Electrician" &&
//               (() => {
//                 const items = [
//                   ["New Ceiling Fan Installation",    new_ceiling_fan_installation],
//                   ["Ceiling Fan Installation",        ceiling_fan_installation],
//                   ["Ceiling Fan Uninstallation",      ceiling_fan_uninstallation],
//                   ["Fan Coil New Winding",            fan_coil_new_winding],
//                   ["Fan Coil Repair",                 fan_coil_repair],
//                   ["Capacitor Setup",                 capacitor_setup],
//                   ["Light Installation",              light_installation],
//                   ["Light Repair",                    light_repair],
//                   ["Exhaust Fan Installation",        exhaust_fan_installation],
//                   ["Exhaust Fan Cleaning",            exhaust_fan_cleaning],
//                   ["Switch Setup",                    switch_setup],
//                   ["Socket Setup",                    socket_setup],
//                   ["Regulator Setup",                 regulator_setup],
//                   ["New Wiring Point",                new_wiring_point],
//                   ["Main Circuit Board Setup",        main_circuit_board_setup],
//                   ["Doorbell Installation",           doorbell_installation],
//                   ["Drill Hole Service",              drill_hole_service],
//                   ["IPS Installation (Existing Line)",ips_installation_existing_line],
//                   ["IPS Installation (New Line)",     ips_new_line_installation],
//                   // ["Full Wiring", Full_wiring],
//                   ["Electrical Checkup", Electrical_checkup],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean" ? val : val > 0
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           {/* <span>{qty}</span> */}
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Home Cleaning */}
//             {service_name === "Home Cleaning" &&
//               (() => {
//                 const items = [
//                   ["Beds", bed],
//                   ["Baths", bath],
//                   ["Drawing/Dining Rooms", dra_din],
//                   ["Kitchen", kitchen],
//                   ["Cloth Wash", cloth],
//                   ["Dishwash", dish],
//                   ["Balconies", balcony],
//                   ["Window Grills", window_grill],
//                   ["Stairs & Railing Cleaning", stairs_and_railing],
//                   ["Carpet Cleaning", carpet_cleaning],
//                   ["Furniture Cleaning", furniture_cleaning],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       // .filter(([_, qty]) => qty > 0)
//                       .filter(([_, val]) =>
//                         typeof val === "boolean" ? val : val > 0
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           {/* <span>{qty}</span> */}
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Plumber */}
//             {service_name === "Plumber" &&
//               (() => {
//                 const items = [
//                   // Basin & Kitchen
//                   ["Angle Valve Setup",                            angle_valve_setup],
//                   ["Basin Tap (Faucet) Setup",                     basin_tap_setup],
//                   ["Magic Pipe (Flexible Drain) Setup",            magic_pipe_setup],
//                   ["Basin Waste / Pop-Up Setup",                   basin_waste_pop_up_setup],
//                   ["New Basin Setup (existing lines)",             new_basin_setup_existing_lines],
//                   ["Kitchen Sink Setup (existing lines)",          kitchen_sink_setup_existing_lines],
//                   ["Sink Blockage Cleaning",                       sink_blockage_cleaning],

//                   // Bathroom fittings & accessories
//                   ["Bathroom Tap / Bib Cock Setup",                bathroom_tap_bib_cock_setup],
//                   ["Tissue Holder Setup",                          tissue_holder_setup],
//                   ["Fill Valve Replacement",                       fill_valve_replacement],
//                   ["Hand Shower (Bidet Spray) Setup",              hand_shower_setup],
//                   ["Soap Dish Setup",                              soap_dish_setup],
//                   ["Bathroom Shelf Setup",                         bathroom_shelf_setup],
//                   ["Mirror (Looking Glass) Setup",                 mirror_setup],
//                   ["Towel Hanger / Ring Setup",                    towel_hanger_setup],
//                   ["Shower Head + Hose Setup",                     shower_head_setup],
//                   ["Concealed Stopcock / Diverter Valve Setup",    concealed_stopcock_setup],
//                   ["Floor Drain Net / Grate Setup",                floor_drain_net_setup],

//                   // Commode (High & Low)
//                   ["Toilet Seat Cover Replacement",                toilet_seat_cover_replacement],
//                   ["Toilet Seat Complete Installation",            toilet_seat_complete_installation],
//                   ["High Commode Installation (existing lines)",   high_commode_installation_existing_lines],
//                   ["Blockage Clearing — High Commode",             blockage_clearing_high_commode],
//                   ["Blockage Clearing — Low Commode",              blockage_clearing_low_commode],

//                   // Cleaning / Heavy
//                   ["Bathroom Drain Line Cleaning (per bathroom)",  bathroom_drain_line_cleaning],

//                   // Geyser & points
//                   ["Geyser Installation",                          geyser_installation],
//                   ["Washing Machine Point Setup (inlet + drain)",  washing_machine_point_setup],
//                   ["Issue Checkup", issue_checkup],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       // .filter(([_, qty]) => qty > 0)
//                       .filter(([_, val]) =>
//                         typeof val === "boolean" ? val : val > 0
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           {/* <span>{qty}</span> */}
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Gas Chula */}
//             {service_name === "Gas Chula" &&
//               (() => {
//                 const items = [
//                   ["Cylinder Type", chulaCylinderType],
//                   ["New Chula Setups", NewchulaSetup],
//                   ["Chula Setups", chulaSetup],
//                   ["Burner Setups", burnerSetup],
//                   ["Burner Cleaning", burnerCleaning],
//                   ["Nozzle Replacements", nozzleReplacement],
//                   ["Issue Checkup", checkIssues],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : false
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* AC Service */}
//             {service_name === "AC Service" &&
//               (() => {
//                 const items = [
//                   ["AC Type", acType],
//                   ["AC Ton", acTon],
//                   // ["New Setup", new_setup],
//                   // ["Installation", installation],
//                   // ["Uninstallation", uninstallation],
//                   // ["Gas Refill", gas_refill],
//                   // ["Cleaning", cleaning],
//                   // ["Issue Checkup", ac_issue_checkup],

//                   ["AC Install (Outdoor - Inside)",  installation_outdoor_inside],
//                   ["AC Install (Outdoor - Outside)", installation_outdoor_outside],
//                   ["AC Uninstall (Outdoor - Inside)",  uninstallation_outdoor_inside],
//                   ["AC Uninstall (Outdoor - Outside)", uninstallation_outdoor_outside],
//                   ["AC Cleaning (Outdoor - Inside)",  cleaning_outdoor_inside],
//                   ["AC Cleaning (Outdoor - Outside)", cleaning_outdoor_outside],
//                   ["Issue Checkup (units)", ac_issue_checkup],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : false
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Filter */}
//             {service_name === "Filter" &&
//               (() => {
//                 const items = [
//                   ["Filter Type", filter_type],
//                   ["New Filter Setup", new_filter_setup],
//                   ["Filter Installation", installation_filter],
//                   ["Filter Uninstallation", uninstallation_filter],
//                   ["Kit Replacement", kit_replacement],
//                   ["Pipe Leak / Replace", pipe_leak_or_replace],
//                   ["Full Servicing", full_servicing],
//                   ["Issue Checkup", check_up],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : false
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}

//             {/* Tutor Service */}
//             {service_name === "Tutor Service" &&
//               (() => {
//                 // helper to ignore empty/"Any"
//                 const clean = (v) =>
//                   v !== undefined &&
//                   v !== null &&
//                   String(v).trim() !== "" &&
//                   String(v).trim().toLowerCase() !== "any";

//                 const items = [
//                   ["Subject", subject],
//                   ["Class/Level", classLevel || selectedOrder.class_level],
//                   ["Medium", medium],
//                   [
//                     "Preferred Tutor Gender",
//                     clean(preferredTutorGender) ? preferredTutorGender : null,
//                   ],
//                   [
//                     "Days per Week",
//                     daysPerWeek
//                       ? `${daysPerWeek} day${
//                           Number(daysPerWeek) > 1 ? "s" : ""
//                         }/week`
//                       : null,
//                   ],
//                   [
//                     "Hours per Day",
//                     hoursPerDay
//                       ? `${hoursPerDay} hour${
//                           Number(hoursPerDay) > 1 ? "s" : ""
//                         }/day`
//                       : null,
//                   ],
//                   ["Priority Institution", priorityInstitution],
//                   ["Salary", salary ? `৳${salary}` : null],
//                 ];

//                 return (
//                   <ul className="adminservitororderhistorydetails-breakdown-list">
//                     {items
//                       .filter(([_, val]) =>
//                         typeof val === "boolean"
//                           ? val
//                           : typeof val === "number"
//                           ? val > 0
//                           : typeof val === "string"
//                           ? val.trim() !== ""
//                           : val !== null && val !== undefined
//                       )
//                       .map(([label, val]) => (
//                         <li key={label}>
//                           <span>{label}</span>
//                           <span>{typeof val === "boolean" ? "Yes" : val}</span>
//                         </li>
//                       ))}
//                   </ul>
//                 );
//               })()}
//           </div>

//           <div className="adminservitororderhistorydetails-detail-card">
//             <h3 className="adminservitororderhistorydetails-detail-title">
//               <i
//                 className="fas fa-comment"
//                 style={{ marginRight: "8px", color: "#f59e0b" }}
//               />
//               Feedback
//             </h3>
//             <div className="adminservitororderhistorydetails-feedback-list">
//               {feedback ? (
//                 <div className="adminservitororderhistorydetails-feedback-item">
//                   <p className="adminservitororderhistorydetails-feedback-comment">
//                     {feedback}
//                   </p>
//                   <p className="adminservitororderhistorydetails-feedback-date">
//                     {formatDateTime(created_at)}
//                   </p>
//                   <hr className="adminservitororderhistorydetails-rating-underline" />
//                 </div>
//               ) : (
//                 <p className="adminservitororderhistorydetails-detail-value">
//                   No feedback available.
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="adminservitororderhistorydetails-modal-footer">
//           <div className="adminservitororderhistorydetails-footer-buttons">
//             <button
//               className="adminservitororderhistorydetails-footer-btn adminservitororderhistorydetails-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaTimes /> Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminservitororderhistorydetails-container">
//       <Card className="adminservitororderhistorydetails-card">
//         <Card.Header className="adminservitororderhistorydetails-header">
//           <div className="adminservitororderhistorydetails-header-content">
//             <Button
//               variant="outline-primary"
//               className="adminservitororderhistorydetails-back-btn"
//               onClick={() => navigate(-1)}
//             >
//               <FaArrowLeft size={14} /> Back
//             </Button>
//             <h3 className="adminservitororderhistorydetails-title">
//               Order History of {servitorName} (#Id-{servitorId})
//             </h3>
//           </div>
//         </Card.Header>
//         <Card.Body>
//           <Row className="mb-3">
//             <Col md={8}>
//               <InputGroup>
//                 <Form.Control
//                   type="text"
//                   placeholder="Search by Order Number"
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setMeta((m) => ({ ...m, page: 1 }));
//                   }}
//                   className="adminservitororderhistorydetails-search"
//                 />
//               </InputGroup>
//             </Col>
//             <Col md={4}>
//               <Form.Group controlId="statusFilter">
//                 <Form.Select
//                   value={filterStatus}
//                   onChange={(e) => {
//                     setFilterStatus(e.target.value);
//                     setMeta((m) => ({ ...m, page: 1 }));
//                   }}
//                   className="adminservitororderhistorydetails-filter-select"
//                 >
//                   <option value="All">All Statuses</option>
//                   <option value="Completed">Completed</option>
//                   <option value="Accepted">Accepted</option>
//                   <option value="In-Progress">In-Progress</option>
//                   <option value="Cancelled by Servitor">
//                     Cancelled by Servitor
//                   </option>
//                   <option value="Cancelled">Cancelled</option>
//                   <option value="Deadline-Timeout">Deadline-Timeout</option>
//                 </Form.Select>
//               </Form.Group>
//             </Col>
//           </Row>

//           {/* Stats come from backend "counts" */}
//           <div className="adminservitororderhistorydetails-stats-container">
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-blue">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-chart-bar"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 TOTAL ORDERS
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {counts.totalOrders}
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-orange">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-clock"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 ACCEPTED
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {counts.accepted}
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-green">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-check-circle"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 COMPLETED
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {counts.completed}
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-red">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-times-circle"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 CANCELLED
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {counts.cancelled}
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-yellow">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-hourglass-end"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 DEADLINE-TIMEOUT
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {counts.DeadlineTimeout}
//               </div>
//             </div>
//             <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-purple">
//               <div className="adminservitororderhistorydetails-stats-icon">
//                 <i className="fas fa-user-times"></i>
//               </div>
//               <div className="adminservitororderhistorydetails-stats-title">
//                 CANCELLED BY SERVITOR
//               </div>
//               <div className="adminservitororderhistorydetails-stats-value">
//                 {counts.cancelledByServitor}
//               </div>
//             </div>
//           </div>

//           {loading && (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           )}
//           {error && (
//             <Alert
//               variant="danger"
//               className="adminservitororderhistorydetails-error"
//             >
//               {error}
//             </Alert>
//           )}
//           {!loading && !error && orders.length === 0 && (
//             <p className="adminservitororderhistorydetails-empty-text">
//               No orders found for this servitor.
//             </p>
//           )}
//           {!loading && orders.length > 0 && (
//             <>
//               <div className="adminservitororderhistorydetails-table-actions">
//                 <Button
//                   className="adminservitororderhistorydetails-export-btn"
//                   onClick={exportPDF}
//                   disabled={counts.totalOrders === 0}
//                 >
//                   <FaDownload /> Download PDF
//                 </Button>
//               </div>

//               <Table
//                 striped
//                 bordered
//                 hover
//                 responsive
//                 className="adminservitororderhistorydetails-table"
//               >
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Order Number</th>
//                     <th>Service</th>
//                     <th>Status</th>
//                     <th>Amount (Tk)</th>
//                     <th>Date</th>
//                     <th>Time</th>
//                     <th>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {orders.map((o, idx) => (
//                     <tr key={o.order_number || idx}>
//                       <td>{idx + 1 + (meta.page - 1) * meta.limit}</td>
//                       <td>{o.order_number}</td>
//                       <td>{o.service_name}</td>
//                       <td>
//                         <span
//                           className={`adminservitororderhistorydetails-badge-${o.status
//                             .toLowerCase()
//                             .replace(/\s+/g, "-")}`}
//                         >
//                           {o.status}
//                         </span>
//                       </td>
//                       <td>{o.price}</td>
//                       <td>{formatDate(o.created_at)}</td>
//                       <td>{new Date(o.created_at).toLocaleTimeString()}</td>
//                       <td>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           className="adminservitororderhistorydetails-action-btn"
//                           onClick={() => handleViewOrder(o)}
//                         >
//                           <BsEye size={16} />
//                         </Button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>

//               <Pagination>
//                 <Pagination.First
//                   onClick={() => handlePageChange(1)}
//                   disabled={meta.page === 1}
//                 />
//                 <Pagination.Prev
//                   onClick={() => handlePageChange(meta.page - 1)}
//                   disabled={meta.page === 1}
//                 />
//                 {(() => {
//                   const getPageItems = (total, current, maxButtons = 7) => {
//                     const pages = [];
//                     pages.push(1);
//                     const siblings = Math.floor((maxButtons - 3) / 2);
//                     let start = Math.max(2, current - siblings);
//                     let end = Math.min(total - 1, current + siblings);
//                     if (current <= siblings + 2)
//                       end = Math.min(total - 1, maxButtons - 1);
//                     if (current >= total - (siblings + 1))
//                       start = Math.max(2, total - (maxButtons - 2));
//                     if (start > 2) pages.push("start-ellipsis");
//                     for (let i = start; i <= end; i++) pages.push(i);
//                     if (end < total - 1) pages.push("end-ellipsis");
//                     if (total > 1) pages.push(total);
//                     return pages;
//                   };
//                   return getPageItems(meta.totalPages, meta.page).map(
//                     (item, idx) => {
//                       if (item === "start-ellipsis" || item === "end-ellipsis")
//                         return (
//                           <Pagination.Ellipsis key={item + idx} disabled />
//                         );
//                       return (
//                         <Pagination.Item
//                           key={item}
//                           active={item === meta.page}
//                           onClick={() => handlePageChange(item)}
//                         >
//                           {item}
//                         </Pagination.Item>
//                       );
//                     }
//                   );
//                 })()}
//                 <Pagination.Next
//                   onClick={() => handlePageChange(meta.page + 1)}
//                   disabled={meta.page === meta.totalPages}
//                 />
//                 <Pagination.Last
//                   onClick={() => handlePageChange(meta.totalPages)}
//                   disabled={meta.page === meta.totalPages}
//                 />
//               </Pagination>
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {showModal && (
//         <div
//           className="adminservitororderhistorydetails-modal-backdrop"
//           ref={modalRef}
//         >
//           {renderOrderDetails()}
//         </div>
//       )}
//     </Container>
//   );
// }





// ***** upper code is okay, Updated with Auth (2-Dec-2025) ***** //
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Container,
  Card,
  Table,
  Button,
  Spinner,
  Alert,
  InputGroup,
  Form,
  Row,
  Col,
  Pagination,
} from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaArrowLeft, FaDownload, FaTimes } from "react-icons/fa";
import { BsEye } from "react-icons/bs";
import "./ServitorOrderHistoryDetails.css";
import { formatDate } from "../../dateTimefrontpart";
import { URL } from "../../../config";

const DEFAULT_LIMIT = 10;

/* ========== Admin Auth Helper ========== */
const getAdminHeaders = () => {
  const adminToken = localStorage.getItem("adminToken");
  return adminToken ? { Authorization: `Bearer ${adminToken}` } : {};
};

export default function ServitorOrderHistoryDetails() {
  const { servitorId } = useParams();
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [servitorName, setServitorName] = useState("");
  const [counts, setCounts] = useState({
    totalOrders: 0,
    accepted: 0,
    completed: 0,
    cancelled: 0,
    cancelledByServitor: 0,
    DeadlineTimeout: 0,
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // filters
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");

  // pagination meta
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
    sortBy: "created_at",
    sortDir: "DESC",
  });

  // modal
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const modalRef = useRef(null);

  const fetchPage = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${URL}/admin/servitors/${servitorId}/orders`,
        {
          headers: getAdminHeaders(),
          params: {
            page: meta.page,
            limit: meta.limit,
            search: searchTerm,
            status: filterStatus === "All" ? "" : filterStatus,
            sortBy: meta.sortBy,
            sortDir: meta.sortDir,
          },
        }
      );

      const list = Array.isArray(data?.data) ? data.data : [];
      setOrders(list);

      if (data?.meta) {
        setMeta((m) => ({ ...m, ...data.meta }));
      } else {
        setMeta((m) => ({
          ...m,
          total: list.length,
          totalPages: 1,
        }));
      }

      if (data?.counts) setCounts(data.counts);
      if (data?.servitor?.name) setServitorName(data.servitor.name);

      setError("");
    } catch (err) {
      console.error("Error loading servitor order details:", err);
      setError("Could not load orders or servitor details.");
      setOrders([]);
      setMeta((m) => ({
        ...m,
        total: 0,
        totalPages: 1,
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    meta.page,
    meta.limit,
    filterStatus,
    searchTerm,
    servitorId,
    meta.sortBy,
    meta.sortDir,
  ]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > meta.totalPages) return;
    setMeta((m) => ({ ...m, page: pageNumber }));
  };

  const exportPDF = async () => {
    try {
      // fetch ALL rows with current filters for export
      const { data } = await axios.get(
        `${URL}/admin/servitors/${servitorId}/orders`,
        {
          headers: getAdminHeaders(),
          params: {
            page: 1,
            limit: 999999, // export everything
            search: searchTerm,
            status: filterStatus === "All" ? "" : filterStatus,
            sortBy: "created_at",
            sortDir: "DESC",
          },
        }
      );

      const allOrders = Array.isArray(data?.data) ? data.data : [];
      if (allOrders.length === 0) return;

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: "a4",
      });
      const pageWidth = doc.internal.pageSize.getWidth();
      const titleText = `Order History -- ${servitorName} (#${servitorId})`;
      const timestampText = `Generated: ${new Date().toLocaleString("en-US", {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })}`;
      const rowsPerPage = 15;
      const totalPages = Math.ceil(allOrders.length / rowsPerPage);

      const renderPage = async (pageIndex) => {
        const sliceStart = pageIndex * rowsPerPage;
        const slice = allOrders.slice(sliceStart, sliceStart + rowsPerPage);

        const wrapper = document.createElement("div");
        Object.assign(wrapper.style, {
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          width: "800px",
          padding: "10px",
          fontSize: "10px",
          background: "white",
          color: "black",
          fontFamily: "Helvetica, Arial, sans-serif",
        });

        const h2 = document.createElement("h2");
        h2.innerText = titleText;
        h2.style.textAlign = "center";
        h2.style.margin = "0 0 5px 0";
        wrapper.appendChild(h2);

        const info = document.createElement("div");
        info.style.display = "flex";
        info.style.justifyContent = "space-between";
        info.style.fontSize = "8px";
        info.innerHTML = `<span>${timestampText}</span><span>Page ${
          pageIndex + 1
        } of ${totalPages}</span>`;
        wrapper.appendChild(info);

        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.borderCollapse = "collapse";
        table.style.marginTop = "5px";
        table.innerHTML = `
          <thead>
            <tr>
              <th style="border:1px solid #444; padding:4px;">#</th>
              <th style="border:1px solid #444; padding:4px;">Order #</th>
              <th style="border:1px solid #444; padding:4px;">Service</th>
              <th style="border:1px solid #444; padding:4px;">Status</th>
              <th style="border:1px solid #444; padding:4px;">Amount (Tk)</th>
              <th style="border:1px solid #444; padding:4px;">Date</th>
              <th style="border:1px solid #444; padding:4px;">Time</th>
            </tr>
          </thead>
          <tbody>
            ${slice
              .map((o, idx) => {
                const globalIdx = sliceStart + idx + 1;
                const date = new Date(o.created_at);
                return `
                <tr>
                  <td style="border:1px solid #444; padding:4px;">${globalIdx}</td>
                  <td style="border:1px solid #444; padding:4px;">${
                    o.order_number
                  }</td>
                  <td style="border:1px solid #444; padding:4px;">${
                    o.service_name
                  }</td>
                  <td style="border:1px solid #444; padding:4px;">${
                    o.status
                  }</td>
                  <td style="border:1px solid #444; padding:4px; text-align:right;">${
                    o.price
                  } Tk</td>
                  <td style="border:1px solid #444; padding:4px;">${date.toLocaleDateString()}</td>
                  <td style="border:1px solid #444; padding:4px;">${date.toLocaleTimeString()}</td>
                </tr>
              `;
              })
              .join("")}
          </tbody>
        `;
        wrapper.appendChild(table);

        document.body.appendChild(wrapper);
        const canvas = await html2canvas(wrapper, { scale: 2 });
        document.body.removeChild(wrapper);

        const imgData = canvas.toDataURL("image/png");
        const margin = 20;
        const imgWidth = pageWidth - margin * 2;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        if (pageIndex > 0) doc.addPage();
        doc.addImage(imgData, "PNG", margin, margin, imgWidth, imgHeight);
      };

      for (let i = 0; i < totalPages; i++) {
        // eslint-disable-next-line no-await-in-loop
        await renderPage(i);
      }
      doc.save(
        `Servitor_${servitorId}_Orders_${
          new Date().toISOString().split("T")[0]
        }.pdf`
      );
    } catch (e) {
      console.error("Failed to export PDF:", e);
    }
  };

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const node = modalRef.current;
    const handleBackdropClick = (e) =>
      node && e.target === node && handleCloseModal();
    const handleEscapeKey = (e) => e.key === "Escape" && handleCloseModal();
    if (node) node.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      if (node) node.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const formatDateTime = (iso) => {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const dateStr = d.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const [month, day, year] = dateStr.replace(",", "").split(" ");
    const datePart = `${day}-${month}-${year}`;
    const timeStr = d
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase();
    return `${datePart}, ${timeStr}`;
  };

  const renderOrderDetails = () => {
    if (!selectedOrder) return null;

    const {
      order_number,
      service_name,
      status,
      price,
      created_at,
      feedback,
      rating,

      // electrician fields
      new_ceiling_fan_installation,
      ceiling_fan_installation,
      ceiling_fan_uninstallation,
      fan_coil_new_winding,
      fan_coil_repair,
      capacitor_setup,
      light_installation,
      light_repair,
      exhaust_fan_installation,
      exhaust_fan_cleaning,
      switch_setup,
      socket_setup,
      regulator_setup,
      new_wiring_point,
      main_circuit_board_setup,
      doorbell_installation,
      drill_hole_service,
      ips_installation_existing_line,
      ips_new_line_installation,
      Electrical_checkup,

      // homeclean fields …
      bed,
      bath,
      dra_din,
      kitchen,
      cloth,
      dish,
      balcony,
      window_grill,
      stairs_and_railing,
      carpet_cleaning,
      furniture_cleaning,

      // plumber fields …
      angle_valve_setup,
      basin_tap_setup,
      magic_pipe_setup,
      basin_waste_pop_up_setup,
      new_basin_setup_existing_lines,
      bathroom_tap_bib_cock_setup,
      tissue_holder_setup,
      fill_valve_replacement,
      hand_shower_setup,
      soap_dish_setup,
      bathroom_shelf_setup,
      mirror_setup,
      towel_hanger_setup,
      shower_head_setup,
      concealed_stopcock_setup,
      floor_drain_net_setup,
      toilet_seat_cover_replacement,
      toilet_seat_complete_installation,
      high_commode_installation_existing_lines,
      blockage_clearing_high_commode,
      blockage_clearing_low_commode,
      bathroom_drain_line_cleaning,
      geyser_installation,
      kitchen_sink_setup_existing_lines,
      sink_blockage_cleaning,
      washing_machine_point_setup,
      issue_checkup,

      // Gas Chula
      chulaCylinderType,
      NewchulaSetup,
      chulaSetup,
      burnerSetup,
      burnerCleaning,
      nozzleReplacement,
      checkIssues,

      // AC Service
      acType,
      acTon,
      installation_outdoor_inside,
      installation_outdoor_outside,
      uninstallation_outdoor_inside,
      uninstallation_outdoor_outside,
      cleaning_outdoor_inside,
      cleaning_outdoor_outside,
      issue_checkup: ac_issue_checkup,

      // Filter service
      filter_type,
      new_filter_setup,
      installation_filter,
      uninstallation_filter,
      kit_replacement,
      pipe_leak_or_replace,
      full_servicing,
      check_up,

      // Tutor service
      subject,
      classLevel,
      medium,
      preferredTutorGender,
      daysPerWeek,
      hoursPerDay,
      priorityInstitution,
      salary,
    } = selectedOrder;

    const numericRating =
      rating != null && !Number.isNaN(Number(rating))
        ? Number(rating)
        : null;

    return (
      <div className="adminservitororderhistorydetails-modal">
        <div className="adminservitororderhistorydetails-modal-header">
          <button
            className="adminservitororderhistorydetails-modal-close"
            onClick={handleCloseModal}
          >
            <FaTimes size={20} />
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="adminservitororderhistorydetails-service-icon">
              <i className="fas fa-tools" style={{ color: "#f59e0b" }} />
            </div>
            <div>
              <h2 className="adminservitororderhistorydetails-modal-title">
                Order Details - #{order_number}
              </h2>
              <p className="adminservitororderhistorydetails-modal-subtitle">
                {service_name} • {status}
              </p>
            </div>
          </div>
        </div>
        <div className="adminservitororderhistorydetails-modal-body">
          <div className="adminservitororderhistorydetails-summary-cards">
            <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-amount-card">
              <div>
                <p className="adminservitororderhistorydetails-detail-text">
                  Amount
                </p>
                <p className="adminservitororderhistorydetails-price-value">
                  ৳{price || 0}
                </p>
              </div>
            </div>
            <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-status-card">
              <div>
                <p className="adminservitororderhistorydetails-detail-text">
                  Status
                </p>
                <p className="adminservitororderhistorydetails-count-value">
                  {status}
                </p>
              </div>
              <i
                className={`fas ${
                  status === "Completed" ? "fa-check-circle" : "fa-info-circle"
                }`}
                style={{
                  color: status === "Completed" ? "#22c55e" : "#2563eb",
                }}
              />
            </div>
            <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-date-card">
              <div>
                <p className="adminservitororderhistorydetails-detail-text">
                  Date & Time
                </p>
                <p className="adminservitororderhistorydetails-detail-value">
                  {formatDateTime(created_at)}
                </p>
              </div>
            </div>
            <div className="adminservitororderhistorydetails-summary-card adminservitororderhistorydetails-rating-card">
              <div>
                <p className="adminservitororderhistorydetails-detail-text">
                  Rating
                </p>
                <p className="adminservitororderhistorydetails-rating-value">
                  {numericRating != null
                    ? `${numericRating.toFixed(1)}`
                    : "N/A"}{" "}
                  / 5
                </p>
                <div className="adminservitororderhistorydetails-star-container">
                  {[...Array(5)].map((_, index) => (
                    <i
                      key={index}
                      className="fas fa-star"
                      style={{
                        color:
                          index < Math.round(numericRating || 0)
                            ? "#f59e0b"
                            : "#e5e7eb",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* ─── SERVICE BREAKDOWN ─── */}
          <div className="adminservitororderhistorydetails-detail-card">
            <h3 className="adminservitororderhistorydetails-detail-title">
              Order Breakdown
            </h3>

            {/* Electrician */}
            {service_name === "Electrician" &&
              (() => {
                const items = [
                  ["New Ceiling Fan Installation", new_ceiling_fan_installation],
                  ["Ceiling Fan Installation", ceiling_fan_installation],
                  ["Ceiling Fan Uninstallation", ceiling_fan_uninstallation],
                  ["Fan Coil New Winding", fan_coil_new_winding],
                  ["Fan Coil Repair", fan_coil_repair],
                  ["Capacitor Setup", capacitor_setup],
                  ["Light Installation", light_installation],
                  ["Light Repair", light_repair],
                  ["Exhaust Fan Installation", exhaust_fan_installation],
                  ["Exhaust Fan Cleaning", exhaust_fan_cleaning],
                  ["Switch Setup", switch_setup],
                  ["Socket Setup", socket_setup],
                  ["Regulator Setup", regulator_setup],
                  ["New Wiring Point", new_wiring_point],
                  ["Main Circuit Board Setup", main_circuit_board_setup],
                  ["Doorbell Installation", doorbell_installation],
                  ["Drill Hole Service", drill_hole_service],
                  ["IPS Installation (Existing Line)", ips_installation_existing_line],
                  ["IPS Installation (New Line)", ips_new_line_installation],
                  ["Electrical Checkup", Electrical_checkup],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean" ? val : val > 0
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}

            {/* Home Cleaning */}
            {service_name === "Home Cleaning" &&
              (() => {
                const items = [
                  ["Beds", bed],
                  ["Baths", bath],
                  ["Drawing/Dining Rooms", dra_din],
                  ["Kitchen", kitchen],
                  ["Cloth Wash", cloth],
                  ["Dishwash", dish],
                  ["Balconies", balcony],
                  ["Window Grills", window_grill],
                  ["Stairs & Railing Cleaning", stairs_and_railing],
                  ["Carpet Cleaning", carpet_cleaning],
                  ["Furniture Cleaning", furniture_cleaning],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean" ? val : val > 0
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}

            {/* Plumber */}
            {service_name === "Plumber" &&
              (() => {
                const items = [
                  ["Angle Valve Setup", angle_valve_setup],
                  ["Basin Tap (Faucet) Setup", basin_tap_setup],
                  ["Magic Pipe (Flexible Drain) Setup", magic_pipe_setup],
                  ["Basin Waste / Pop-Up Setup", basin_waste_pop_up_setup],
                  ["New Basin Setup (existing lines)", new_basin_setup_existing_lines],
                  ["Kitchen Sink Setup (existing lines)", kitchen_sink_setup_existing_lines],
                  ["Sink Blockage Cleaning", sink_blockage_cleaning],
                  ["Bathroom Tap / Bib Cock Setup", bathroom_tap_bib_cock_setup],
                  ["Tissue Holder Setup", tissue_holder_setup],
                  ["Fill Valve Replacement", fill_valve_replacement],
                  ["Hand Shower (Bidet Spray) Setup", hand_shower_setup],
                  ["Soap Dish Setup", soap_dish_setup],
                  ["Bathroom Shelf Setup", bathroom_shelf_setup],
                  ["Mirror (Looking Glass) Setup", mirror_setup],
                  ["Towel Hanger / Ring Setup", towel_hanger_setup],
                  ["Shower Head + Hose Setup", shower_head_setup],
                  ["Concealed Stopcock / Diverter Valve Setup", concealed_stopcock_setup],
                  ["Floor Drain Net / Grate Setup", floor_drain_net_setup],
                  ["Toilet Seat Cover Replacement", toilet_seat_cover_replacement],
                  ["Toilet Seat Complete Installation", toilet_seat_complete_installation],
                  [
                    "High Commode Installation (existing lines)",
                    high_commode_installation_existing_lines,
                  ],
                  ["Blockage Clearing — High Commode", blockage_clearing_high_commode],
                  ["Blockage Clearing — Low Commode", blockage_clearing_low_commode],
                  ["Bathroom Drain Line Cleaning (per bathroom)", bathroom_drain_line_cleaning],
                  ["Geyser Installation", geyser_installation],
                  ["Washing Machine Point Setup (inlet + drain)", washing_machine_point_setup],
                  ["Issue Checkup", issue_checkup],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean" ? val : val > 0
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}

            {/* Gas Chula */}
            {service_name === "Gas Chula" &&
              (() => {
                const items = [
                  ["Cylinder Type", chulaCylinderType],
                  ["New Chula Setups", NewchulaSetup],
                  ["Chula Setups", chulaSetup],
                  ["Burner Setups", burnerSetup],
                  ["Burner Cleaning", burnerCleaning],
                  ["Nozzle Replacements", nozzleReplacement],
                  ["Issue Checkup", checkIssues],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean"
                          ? val
                          : typeof val === "number"
                          ? val > 0
                          : typeof val === "string"
                          ? val.trim() !== ""
                          : false
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}

            {/* AC Service */}
            {service_name === "AC Service" &&
              (() => {
                const items = [
                  ["AC Type", acType],
                  ["AC Ton", acTon],
                  ["AC Install (Outdoor - Inside)", installation_outdoor_inside],
                  ["AC Install (Outdoor - Outside)", installation_outdoor_outside],
                  ["AC Uninstall (Outdoor - Inside)", uninstallation_outdoor_inside],
                  ["AC Uninstall (Outdoor - Outside)", uninstallation_outdoor_outside],
                  ["AC Cleaning (Outdoor - Inside)", cleaning_outdoor_inside],
                  ["AC Cleaning (Outdoor - Outside)", cleaning_outdoor_outside],
                  ["Issue Checkup (units)", ac_issue_checkup],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean"
                          ? val
                          : typeof val === "number"
                          ? val > 0
                          : typeof val === "string"
                          ? val.trim() !== ""
                          : false
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}

            {/* Filter */}
            {service_name === "Filter" &&
              (() => {
                const items = [
                  ["Filter Type", filter_type],
                  ["New Filter Setup", new_filter_setup],
                  ["Filter Installation", installation_filter],
                  ["Filter Uninstallation", uninstallation_filter],
                  ["Kit Replacement", kit_replacement],
                  ["Pipe Leak / Replace", pipe_leak_or_replace],
                  ["Full Servicing", full_servicing],
                  ["Issue Checkup", check_up],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean"
                          ? val
                          : typeof val === "number"
                          ? val > 0
                          : typeof val === "string"
                          ? val.trim() !== ""
                          : false
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}

            {/* Tutor Service */}
            {service_name === "Tutor Service" &&
              (() => {
                const clean = (v) =>
                  v !== undefined &&
                  v !== null &&
                  String(v).trim() !== "" &&
                  String(v).trim().toLowerCase() !== "any";

                const items = [
                  ["Subject", subject],
                  ["Class/Level", classLevel || selectedOrder.class_level],
                  ["Medium", medium],
                  [
                    "Preferred Tutor Gender",
                    clean(preferredTutorGender) ? preferredTutorGender : null,
                  ],
                  [
                    "Days per Week",
                    daysPerWeek
                      ? `${daysPerWeek} day${
                          Number(daysPerWeek) > 1 ? "s" : ""
                        }/week`
                      : null,
                  ],
                  [
                    "Hours per Day",
                    hoursPerDay
                      ? `${hoursPerDay} hour${
                          Number(hoursPerDay) > 1 ? "s" : ""
                        }/day`
                      : null,
                  ],
                  ["Priority Institution", priorityInstitution],
                  ["Salary", salary ? `৳${salary}` : null],
                ];

                return (
                  <ul className="adminservitororderhistorydetails-breakdown-list">
                    {items
                      .filter(([_, val]) =>
                        typeof val === "boolean"
                          ? val
                          : typeof val === "number"
                          ? val > 0
                          : typeof val === "string"
                          ? val.trim() !== ""
                          : val !== null && val !== undefined
                      )
                      .map(([label, val]) => (
                        <li key={label}>
                          <span>{label}</span>
                          <span>
                            {typeof val === "boolean" ? "Yes" : val}
                          </span>
                        </li>
                      ))}
                  </ul>
                );
              })()}
          </div>

          <div className="adminservitororderhistorydetails-detail-card">
            <h3 className="adminservitororderhistorydetails-detail-title">
              <i
                className="fas fa-comment"
                style={{ marginRight: "8px", color: "#f59e0b" }}
              />
            </h3>
            <div className="adminservitororderhistorydetails-feedback-list">
              {feedback ? (
                <div className="adminservitororderhistorydetails-feedback-item">
                  <p className="adminservitororderhistorydetails-feedback-comment">
                    {feedback}
                  </p>
                  <p className="adminservitororderhistorydetails-feedback-date">
                    {formatDateTime(created_at)}
                  </p>
                  <hr className="adminservitororderhistorydetails-rating-underline" />
                </div>
              ) : (
                <p className="adminservitororderhistorydetails-detail-value">
                  No feedback available.
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="adminservitororderhistorydetails-modal-footer">
          <div className="adminservitororderhistorydetails-footer-buttons">
            <button
              className="adminservitororderhistorydetails-footer-btn adminservitororderhistorydetails-footer-btn-close"
              onClick={handleCloseModal}
            >
              <FaTimes /> Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    if (!total || total < 1) return [1];
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1))
      start = Math.max(2, total - (maxButtons - 2));
    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  return (
    <Container fluid className="adminservitororderhistorydetails-container">
      <Card className="adminservitororderhistorydetails-card">
        <Card.Header className="adminservitororderhistorydetails-header">
          <div className="adminservitororderhistorydetails-header-content">
            <Button
              variant="outline-primary"
              className="adminservitororderhistorydetails-back-btn"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeft size={14} /> Back
            </Button>
            <h3 className="adminservitororderhistorydetails-title">
              Order History of {servitorName} (#Id-{servitorId})
            </h3>
          </div>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={8}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search by Order Number"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                  className="adminservitororderhistorydetails-search"
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <Form.Group controlId="statusFilter">
                <Form.Select
                  value={filterStatus}
                  onChange={(e) => {
                    setFilterStatus(e.target.value);
                    setMeta((m) => ({ ...m, page: 1 }));
                  }}
                  className="adminservitororderhistorydetails-filter-select"
                >
                  <option value="All">All Statuses</option>
                  <option value="Completed">Completed</option>
                  <option value="Accepted">Accepted</option>
                  <option value="In-Progress">In-Progress</option>
                  <option value="Cancelled by Servitor">
                    Cancelled by Servitor
                  </option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Deadline-Timeout">Deadline-Timeout</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* Stats come from backend "counts" */}
          <div className="adminservitororderhistorydetails-stats-container">
            <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-blue">
              <div className="adminservitororderhistorydetails-stats-icon">
                <i className="fas fa-chart-bar"></i>
              </div>
              <div className="adminservitororderhistorydetails-stats-title">
                TOTAL ORDERS
              </div>
              <div className="adminservitororderhistorydetails-stats-value">
                {counts.totalOrders}
              </div>
            </div>
            <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-orange">
              <div className="adminservitororderhistorydetails-stats-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="adminservitororderhistorydetails-stats-title">
                ACCEPTED
              </div>
              <div className="adminservitororderhistorydetails-stats-value">
                {counts.accepted}
              </div>
            </div>
            <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-green">
              <div className="adminservitororderhistorydetails-stats-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <div className="adminservitororderhistorydetails-stats-title">
                COMPLETED
              </div>
              <div className="adminservitororderhistorydetails-stats-value">
                {counts.completed}
              </div>
            </div>
            <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-red">
              <div className="adminservitororderhistorydetails-stats-icon">
                <i className="fas fa-times-circle"></i>
              </div>
              <div className="adminservitororderhistorydetails-stats-title">
                CANCELLED
              </div>
              <div className="adminservitororderhistorydetails-stats-value">
                {counts.cancelled}
              </div>
            </div>
            <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-yellow">
              <div className="adminservitororderhistorydetails-stats-icon">
                <i className="fas fa-hourglass-end"></i>
              </div>
              <div className="adminservitororderhistorydetails-stats-title">
                DEADLINE-TIMEOUT
              </div>
              <div className="adminservitororderhistorydetails-stats-value">
                {counts.DeadlineTimeout}
              </div>
            </div>
            <div className="adminservitororderhistorydetails-stats-card adminservitororderhistorydetails-purple">
              <div className="adminservitororderhistorydetails-stats-icon">
                <i className="fas fa-user-times"></i>
              </div>
              <div className="adminservitororderhistorydetails-stats-title">
                CANCELLED BY SERVITOR
              </div>
              <div className="adminservitororderhistorydetails-stats-value">
                {counts.cancelledByServitor}
              </div>
            </div>
          </div>

          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}
          {error && (
            <Alert
              variant="danger"
              className="adminservitororderhistorydetails-error"
            >
              {error}
            </Alert>
          )}
          {!loading && !error && orders.length === 0 && (
            <p className="adminservitororderhistorydetails-empty-text">
              No orders found for this servitor.
            </p>
          )}
          {!loading && orders.length > 0 && (
            <>
              <div className="adminservitororderhistorydetails-table-actions">
                <Button
                  className="adminservitororderhistorydetails-export-btn"
                  onClick={exportPDF}
                  disabled={counts.totalOrders === 0}
                >
                  <FaDownload /> Download PDF
                </Button>
              </div>

              <Table
                striped
                bordered
                hover
                responsive
                className="adminservitororderhistorydetails-table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Order Number</th>
                    <th>Service</th>
                    <th>Status</th>
                    <th>Amount (Tk)</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((o, idx) => (
                    <tr key={o.order_number || idx}>
                      <td>{idx + 1 + (meta.page - 1) * meta.limit}</td>
                      <td>{o.order_number}</td>
                      <td>{o.service_name}</td>
                      <td>
                        <span
                          className={`adminservitororderhistorydetails-badge-${String(
                            o.status || ""
                          )
                            .toLowerCase()
                            .replace(/\s+/g, "-")}`}
                        >
                          {o.status}
                        </span>
                      </td>
                      <td>{o.price}</td>
                      <td>{formatDate(o.created_at)}</td>
                      <td>{new Date(o.created_at).toLocaleTimeString()}</td>
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="adminservitororderhistorydetails-action-btn"
                          onClick={() => handleViewOrder(o)}
                        >
                          <BsEye size={16} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Pagination>
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={meta.page === 1}
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(meta.page - 1)}
                  disabled={meta.page === 1}
                />
                {getPageItems(meta.totalPages, meta.page).map((item, idx) => {
                  if (item === "start-ellipsis" || item === "end-ellipsis") {
                    return <Pagination.Ellipsis key={item + idx} disabled />;
                  }
                  return (
                    <Pagination.Item
                      key={item}
                      active={item === meta.page}
                      onClick={() => handlePageChange(item)}
                    >
                      {item}
                    </Pagination.Item>
                  );
                })}
                <Pagination.Next
                  onClick={() => handlePageChange(meta.page + 1)}
                  disabled={meta.page === meta.totalPages}
                />
                <Pagination.Last
                  onClick={() => handlePageChange(meta.totalPages)}
                  disabled={meta.page === meta.totalPages}
                />
              </Pagination>
            </>
          )}
        </Card.Body>
      </Card>

      {showModal && (
        <div
          className="adminservitororderhistorydetails-modal-backdrop"
          ref={modalRef}
        >
          {renderOrderDetails()}
        </div>
      )}
    </Container>
  );
}
